import _extends from "@babel/runtime/helpers/extends";
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { xor } from 'lodash-es';
import AccordionPanel from './AccordionPanel';
import { AccordionWrapper } from './styles';
const Accordion = ({
  children,
  exclusive = true,
  defaultOpenItems = [],
  openItems: openItemsProp,
  onToggle,
  variation = 'normal',
  ...props
}) => {
  const [openItems, setOpenItems] = useState(defaultOpenItems);
  const handleToggle = id => {
    if (onToggle) {
      onToggle(id);
      return;
    }
    if (exclusive) {
      setOpenItems(openItems[0] === id ? [] : [id]);
      return;
    }
    setOpenItems(state => xor(state, [id]));
  };
  return /*#__PURE__*/React.createElement(AccordionWrapper, _extends({
    $variation: variation
  }, props), React.Children.map(children, child => /*#__PURE__*/React.cloneElement(child, {
    openItems: openItemsProp || openItems,
    onToggle: handleToggle
  })));
};
Accordion.propTypes = {
  exclusive: PropTypes.bool,
  defaultOpenItems: PropTypes.arrayOf(PropTypes.string),
  /** Use for controlled component */
  openItems: PropTypes.arrayOf(PropTypes.string),
  variation: PropTypes.oneOf(['normal', 'borderless', 'group']),
  onToggle: PropTypes.func
};
Accordion.Panel = AccordionPanel;
export { AccordionPanel };
export default Accordion;
//# sourceMappingURL=index.js.map